import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { islogined } from "../../utils/loginHandler";

export default function Home() {
  const navigate = useNavigate();
  useEffect(() => {
    const authenticated = islogined();
    if (!authenticated) {
      navigate("/login");
    } else {
      navigate("/dashboard/overview");
    }
  }, []);
  return <div className="w-full h-screen flex justify-center items-center">Loading...</div>;
}
